/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import DomEventsManager from 'scripts/dom-events-manager';
import FacebookApi from 'scripts/social/facebook';
import can from 'can/util/util';
import template from './facebook-embed.stache';
import IframeClickHandler from 'scripts/services/iframe-click-service';

const POST_INIT_TIMEOUT = 200;
const WATCH_PARENT_WIDTH_INTERVAL = 1000 / 30;

Component.extend({
    tag: 'facebook-embed',
    template: template,
    viewModel: {
        define: {
            isHidden: {
                type: 'boolean',
                value: true,
            },
            width: {
                type: 'string',
            },
            postUrl: {
                type: 'string',
                value: '',
            },
        },
    },
    helpers: {
        onRender: function() {
            return function(el) {
                clearTimeout(this.initPostTimeout);
                this.initPostTimeout = setTimeout(() => {
                    FacebookApi.create(el.parentElement);
                }, POST_INIT_TIMEOUT);
            }.bind(this);
        },
    },
    events: {
        inserted: function() {
            DomEventsManager.subscribe(this);
        },

        registerClickListener() {
            this.iframeListener = new IframeClickHandler('.c-facebook-embed');
            this.iframeListener.subscribe(() => this.element.trigger('click'));
        },

        removed() {
            if (Boolean(this.iframeListener)) {
                this.iframeListener.unsubscribe();
            }
            DomEventsManager.unsubscribe(this);
        },

        onLayout: function(layout) {
            if (
                !this.waitParentWidthDeferred ||
                this.waitParentWidthDeferred.state() !== 'pending'
            ) {
                this.waitParentWidthDeferred = this.watchParentWidth().then(
                    (width) => {
                        this.viewModel.attr({
                            isHidden: false,
                            width: this.getPostWidth(layout, width),
                        });
                    },
                );
            }
        },

        onWindowResize: function() {
            let parentWidth = this.element.find('.s-iframe-wrapper').width();
            this.viewModel.attr('width', this.getPostWidth(parentWidth));
        },

        watchParentWidth: function() {
            let deferred = can.Deferred();
            let width = -1;
            let count = 3;

            let interval = setInterval(() => {
                let currentWidth = this.element
                    .find('.s-iframe-wrapper')
                    .width();

                if (width === currentWidth) {
                    count--;
                    if (count === 0) {
                        clearInterval(interval);
                        deferred.resolve(width);
                    }
                }

                width = currentWidth;
            }, WATCH_PARENT_WIDTH_INTERVAL);

            return deferred.promise();
        },

        getPostWidth: function(layout, width) {
            return layout === 'extra-small' ? 'auto' : width;
        },
    },
});
